import styled from "styled-components";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {baseColors} from "../../../../../themes/definitions/mrgreen/base-colors";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";

const FilterCategoryDefaultBox = styled.div`
  padding: 2rem 0;
  border-bottom: 1px solid ${props => props.theme.colors.boxBorderLighter};
  box-sizing: border-box;
`;

const FilterCategorySIBox = styled(FilterCategoryDefaultBox)`
  border-bottom: 2px solid ${props => props.theme.colors.boxBorderDark};
`

const FilterCategoryMrGreenBox = styled(FilterCategoryDefaultBox)`
  border-bottom: 1px solid ${hexToRgba(baseColors.gray233, 0.3)};
`;

export const FilterCategoryBox = styledByTheme(FilterCategoryDefaultBox)
    .forSI(FilterCategorySIBox)
    .forSICis(FilterCategorySIBox)
    .forMrGreen(FilterCategoryMrGreenBox)
    .forMrGreenCis(FilterCategoryMrGreenBox).apply();
